<template>
  <div class="drawer__header" data-js="get-height">
    <v-layout align-center justify-start>
      <v-btn
        v-if="history.length > 1"
        icon
        @click="goBack"
      >
        <v-icon color="gray-6">keyboard_arrow_left</v-icon>
      </v-btn>

      <v-flex class="drawer__title">{{ $t(`${namespace}.title`) }}</v-flex>
    </v-layout>

    <div>
      <v-tooltip
        v-if="hasRole('employee', 'ROLE_POST_EMPLOYEE_ID_RESENDWELCOMEEMAIL')"
        max-width="177"
        top
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            class="mx-0"
            icon
            @click="handleResendWelcomeEmail"
          >
            <v-icon color="gray-6">email</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('Views.EmployeesPage.table.dropdown.sendEmail') }}</span>
      </v-tooltip>

      <v-tooltip
        v-if="hasRole('employee', 'ROLE_PUT_EMPLOYEE_ID_ADDTOALLCOSTCENTERS')"
        max-width="177"
        top
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            class="mx-0"
            icon
            @click="handleAddToAllCostCenters"
          >
            <v-icon color="gray-6">supervised_user_circle</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('Views.EmployeesPage.table.dropdown.addToAllCostCenters') }}</span>
      </v-tooltip>

      <v-menu
        v-if="hasRole('employee', 'ROLE_PUT_EMPLOYEE_ID') || hasRole('employee', 'ROLE_DELETE_EMPLOYEE_ID')"
        offset-y
        left
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="btn--more_vertical"
            icon
          >
            <v-icon color="gray-6">more_vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-if="hasRole('employee', 'ROLE_PUT_EMPLOYEE_ID')"
            @click="$router.push({
              name: 'Employee',
              params: { type: 'editar', id: data.employee.id }
            })"
          >
            <v-list-item-title>
              {{ $t('Views.EmployeesPage.table.dropdown.editEmployee') }}
            </v-list-item-title>
          </v-list-item>

          <v-divider v-if="hasRole('employee', 'ROLE_PUT_EMPLOYEE_ID') && hasRole('employee', 'ROLE_DELETE_EMPLOYEE_ID')" />

          <v-list-item
            v-if="hasRole('employee', 'ROLE_DELETE_EMPLOYEE_ID')"
            @click="openSingleDeleteDialog"
          >
            <v-list-item-title>{{ $t('Views.EmployeesPage.table.dropdown.deleteEmployee') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn icon @click="close()">
        <v-icon color="gray-6">close</v-icon>
      </v-btn>
    </div>

    <SingleDeleteDialog
      :visible="singleDeleteDialog"
      :item="data.employee"
      @close="closeSingleDeleteDialog"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import globalLoaderMixin from 'mixins/globalLoader'
import SingleDeleteDialog from 'components/pages/employees/dialogs/SingleDeleteDialog'
import { hasRole } from 'utils/functions'
import { catchError } from 'corp-front-vue-commons/src/utils/functions'

export default {
  name: 'Header',
  mixins: [globalLoaderMixin],
  props: {
    history: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    SingleDeleteDialog
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.employee.header',
      singleDeleteDialog: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    hasRole (group, role) {
      return hasRole(group, role)
    },

    goBack () {
      this.$emit('goBack')
    },

    close (reload = null) {
      this.$emit('close', reload)
    },

    async handleResendWelcomeEmail () {
      this.openGlobalLoader()

      try {
        const { id, name } = this.data.employee
        await this.$apiService.employee.resendWelcomeEmail(id)

        this.showAlert({
          type: 'success',
          message: this.$t('Views.EmployeesPage.resendEmail.success').replace('[VAL]', name)
        })
      } catch (error) {
        this.showAlert({
          type: 'error',
          message: this.$t('Views.EmployeesPage.resendEmail.error')
        })
        catchError(error)
      }

      this.closeGlobalLoader()
    },

    async handleAddToAllCostCenters () {
      this.openGlobalLoader()

      try {
        const { id } = this.data.employee
        await this.$apiService.employee.addToAllCostCenters(id, { id })

        this.showAlert({
          type: 'success',
          message: this.$t('Views.EmployeesPage.addToAllCostCenters.success')
        })
      } catch (error) {
        this.showAlert({
          type: 'error',
          message: this.$t('Views.EmployeesPage.addToAllCostCenters.error')
        })
        catchError(error)
      }

      this.closeGlobalLoader()
    },

    openSingleDeleteDialog () {
      this.singleDeleteDialog = true
    },

    closeSingleDeleteDialog (reload) {
      this.singleDeleteDialog = false
      reload && this.close(reload)
    }
  }
}
</script>
